<template lang="en">
<div>
            <div class="breadcrumb-list">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item active">Profile</li>
                </ol>
                <div class="emp-button btn-align text-right">
                    <button type="button" data-toggle="modal" data-target="#creat-employee" class="btn btn-outline-primary">Create New Employee</button>
                </div>
            </div>
            <div class="main-box two-column">
                <div class="right-side right-side-reverse">

                    <ul class="vertical-menu">
                        <li>
                            <router-link :to="{path: '/employee/shift/'+employeeData.id+''}">{{ employeeData.name }} Shifts</router-link>
                        </li>
                        <li>
                            <router-link :to="{path: '/employee/absence/'+employeeData.id+''}">Leaves</router-link>
                        </li>
                        <li>
                            <router-link :to="{path: '/employee/hours/'+employeeData.id+''}">Hours</router-link>
                        </li>
                        <li class="active">
                            <router-link :to="{path: '/employee/profile/'+employeeData.id+''}">personal info</router-link>
                        </li>
                        <li>
                            <router-link :to="{path: '/employee/salary/'+employeeData.id+''}">Salary Slip</router-link>
                        </li>
                        <li>
                            <router-link :to="{path: '/employee/detail/'+employeeData.id+''}">Employment Details</router-link>
                        </li>
                        <li><router-link :to="{path: '/employee/benefits/'+employeeData.id+''}">Benefits</router-link></li>
                    </ul>
                </div>
                <div class="emplyee-info-wrp">
                    <div class="personal-info-box">
                        <div class="personal-head">
                            <div class="img-wrap">
                                <img src="/assets/img/male-avatar.png" alt="">
                            </div>
                            <strong class="personal-name"> {{ fullName }}</strong>
                        </div>
                        <div class="personal-info-hold">
                            <div class="personal-info-row">
                                <h2>Personal Info</h2>
                                <div class="form-row">
                                    <div class="form-group">
                                        <label for="">phone Number</label>
                                        <div class="input-wrp select-option">
                                            <input type="tel" class="form-control" v-model="employeeData.phone" :readonly="readOnlyField">
                                            <select class="custom-selection" :disabled="diableField">
                                                <option value="">+92</option>
                                                <option value="">+92</option>
                                                <option value="">+92</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="">Employee Number</label>
                                        <div class="input-wrp">
                                            <input type="text" class="form-control" v-model="employeeData.reg_no" :readonly="readOnlyField">
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="">E-mail</label>
                                        <div class="input-wrp">
                                            <input type="email" class="form-control" v-model="employeeData.email" :readonly="readOnlyField">
                                        </div>
                                    </div>
                                    <div class="form-group lg">
                                        <label for="">Address</label>
                                        <div class="input-wrp">
                                            <textarea class="form-control" v-model="employeeData.address" :readonly="readOnlyField"></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="personal-info-row">
                                <h2>Emergency Contact</h2>
                                <div class="form-row">
                                    <div class="form-group">
                                        <label for="">Name</label>
                                        <div class="input-wrp">
                                            <input type="text" class="form-control" v-model="employeeData.emergency_contact_name" :readonly="readOnlyField">
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="">Relationship</label>
                                        <div class="input-wrp">
                                            <input type="text" class="form-control" v-model="employeeData.emergency_relation" :readonly="readOnlyField">
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="">phone Number</label>
                                        <div class="input-wrp select-option">
                                            <input type="tel" class="form-control" v-model="employeeData.emergency_contact_phone" :readonly="readOnlyField">
                                            <select class="custom-selection" :disabled="diableField">
                                                <option value="">+92</option>
                                                <option value="">+92</option>
                                                <option value="">+92</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="personal-info-row">
                                <h2>Payment Information</h2>
                                <div class="form-row">
                                    <div class="form-group">
                                        <label for="">Select Bank</label>
                                        <div class="input-wrp">
                                            <select class="form-control" :disabled="diableField">
                                                <option value="">Bank Alfalah</option>
                                                <option value="">Bank Alfalah</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="">Account No.</label>
                                        <div class="input-wrp">
                                            <input type="text" class="form-control" v-model="employeeData.account_no" :readonly="readOnlyField">
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="">IBAN</label>
                                        <div class="input-wrp">
                                            <input type="text" class="form-control" v-model="employeeData.account_iban" :readonly="readOnlyField">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="tfoot">
                            <button type="button" class="btn btn-outline-primary" @click="editProfile" ref="editProfileBtn">Edit Profile</button>
                            <button type="button" class="btn btn-outline-danger" v-show="diableField" @click="deleteEmployee">Delete Profile</button>
                        </div>
                    </div>

                </div>
            </div>

        <createEmployeeModal></createEmployeeModal>

</div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import createEmployeeModal from "../Employees/createEmployeeModal";
import DatePicker from 'vue2-datepicker'
export default {
    name: "userProfile",
    components: {
        Multiselect,
        createEmployeeModal,
        DatePicker
    },
    data() {
        return {
            employeeData: [],
            getCompanies: this.$store.getters.getUser.companies,
            getCompanyBenefits: this.$store.getters.getSelectedCompany.companyBenefits,
            jobRoles: this.$store.getters.getSelectedCompany.jobRoles,
            selectedCompanyName: this.$store.getters.getSelectedCompany.name,
            currency: this.$store.getters.getSelectedCompany.currency,
            employeeJobRole: [],
            checkAttendance: false,
            remoteWork: '',
            managerAccess: '',
            salary_period2: 30,
            type: 'password',
            fname: '',
            lname: '',
            showNewBtn: false,
            leaveValidate: '',
            employeeAllownces: "",
            fullName: '',
            readOnlyField:true,
            diableField:true
        }
    },
    mounted() {
        this.getEmployeeData();
        this.getAllownces();
        $('.mx-input').addClass('picker-input');
    },
    methods: {
      editProfile(){
       // console.log(this.$refs.editProfileBtn.innerHTML,'editProfileBtn')
        if(this.$refs.editProfileBtn.innerHTML === 'Edit Profile'){
          this.$refs.editProfileBtn.innerHTML = 'Update';
          this.readOnlyField = false;
          this.diableField = false;
        }else if(this.$refs.editProfileBtn.innerHTML === 'Update'){
          this.readOnlyField = true;
          this.diableField = true;
          this.employeeData.empl_role = this.employeeJobRole.map(id => id.id);
          this.employeeData["company"] = this.employeeData.employee_company_id
            this.employeeData['fname'] = this.fname;
            this.employeeData['lname'] = this.lname;
          this.$axios({
            method: "PUT",
              data: this.employeeData,
              url: this.$EmployeeUpdate,
              headers: this.getAuthHeader()
          }).then(res => {
            if (res.data.status == 200) {
                this.$refs.editProfileBtn.innerHTML = 'Edit Profile';
                  // this.$router.go(0);
                  $('#profile-employee').modal('hide');
                  $('#emergency-employee').modal('hide');
                  $('#paymentInfo-employee').modal('hide');
                  this.getEmployeeData();
                  $root.$toast.success('Profile updated!');
              }
          });

        }
      },
        delAllownce(empId, benefitId) {
            var userId = this.$store.getters.getUser.companies[0].user_id;
            var paramss = {
                employee_id: empId,
                benefits_id: benefitId,
                user_id: userId
            }
            this.$axios
                .get(this.$deleteAllownces, {
                    params: paramss,
                    headers: this.getAuthHeader()
                })
                .then(response => {
                    if (response.data.status == 200) {
                        alert('delete allownce successfully');
                        this.getAllownces();
                    }
                })
                .catch(error => {
                    console.log(error);
                })
        },
        getAllownces() {
            var comp_id = this.$store.getters.getSelectedCompany.id;
            var id = this.$route.params.id;
            var paramss = {
                employee_id: id,
                company_id: comp_id
            }

            this.$axios
                .get(this.$getAllAllownces, {
                    params: paramss,
                    headers: this.getAuthHeader()
                })
                .then(response => {
                    if (response.data.status == 200) {
                        this.employeeAllownces = response.data.result;
                        // console.log('employee',this.employeeAllownces);
                    }
                })
                .catch(error => {
                    console.log(error);
                })
        },
        leavesCheckforHalf(event) {
            var decimal = (event.target.value - Math.floor(event.target.value)) !== 0;
            if (decimal && event.target.value === '2.5' || decimal && event.target.value === '1.5') {
                this.employeeData.monthly_allow_leaves = event.target.value;
                this.leaveValidate = '';
                this.checkAttendance = false;
            } else {
                if (decimal) {
                    this.leaveValidate = 'invalid';
                    this.checkAttendance = true;
                } else {
                    this.employeeData.monthly_allow_leaves = event.target.value;
                    this.leaveValidate = '';
                    this.checkAttendance = false;
                }
            }
        },
        calc_hrs_rate() {
            if (this.employeeData.weekly_hours !== '') {
                this.employeeData.monthly_hours = this.employeeData.weekly_hours * 4;
            } else {
                this.employeeData.monthly_hours = 0;
            }

            this.employeeData.hourly_rate = Math.round(this.employeeData.basic_salary / (this.employeeData.weekly_hours * 4)) || 0;
            if (this.employeeData.hourly_rate === Infinity)
                this.employeeData.hourly_rate = 0;
        },
        updateEmployeeProfile(e) {
            this.employeeData.empl_role = this.employeeJobRole.map(id => id.id);
            this.employeeData['remoteWork'] = this.remoteWork;
            this.employeeData['managerAccess'] = this.managerAccess;
            this.employeeData["company"] = this.employeeData.employee_company_id
            this.employeeData['fname'] = this.fname;
            this.employeeData['lname'] = this.lname;
            this.$axios({
                method: "PUT",
                data: this.employeeData,
                url: this.$EmployeeUpdate,
                headers: this.getAuthHeader()
            }).then(res => {
                if (res.data.status == 200) {
                    // this.$router.go(0);
                    $('#profile-employee').modal('hide');
                    $('#emergency-employee').modal('hide');
                    $('#paymentInfo-employee').modal('hide');
                    this.getEmployeeData();
                    $root.$toast.success('Profile updated!');
                }
            });
        },
        deleteEmployee(){
          if(confirm('Are you sure you want to delete this employee?')){
            var id = this.$route.params.id;
            this.$axios({
              method: "DELETE",
              data: {
                id:id
              },
              url: this.$DeleteEmployee+`/${id}`,
              headers: this.getAuthHeader()
            }).then(res => {
              if(res.data.status == 200){
                this.$router.push({ name: "employees" });
                $root.$toast.success('Employee deleted successfully!');
              }
            });
          }
        },
        getEmployeeData() {
            this.employeeJobRole = [];
            var id = this.$route.params.id;
            this.$axios({
                method: "get",
                params: {
                    user_id: id,
                    company_id: this.$store.getters.getSelectedCompany.id
                },
                url: this.$GetEmployeeProfile,
                headers: this.getAuthHeader()
            }).then(res => {
                if (res.data.status == 200) {
                    this.employeeData = res.data.result[0];
                    this.employeeData.employment_date = new Date(this.employeeData.employment_date);
                    this.remoteWork = this.employeeData.remoteWork;
                    this.managerAccess = this.employeeData.managerAccess;
                    this.$store.commit('setEmployeeProfileId', this.employeeData);
                    this.employeeData.employeeJobType.map(type => this.employeeJobRole.push(type.get_job_roles));
                    this.fullName = this.employeeData.name.substring(0, 1).toUpperCase() + this.employeeData.name.substring(1);
                    let splitName = this.employeeData.name.split(" ");
                    this.fname = splitName[0];
                    this.lname = splitName[1];
                    this.showNewBtn = this.employeeData.lastId == this.$route.params.id ? true : false;
                }
            });
        },
        getCompanyRoles(event, empl_id) {
            var comp_id = this.$store.getters.getSelectedCompany.id
            this.employeeJobRole = [];
            if (comp_id == event.target.value) {
                this.employeeData.employeeJobType.map(type => this.employeeJobRole.push(type.get_job_roles));
            } else {
                this.employeeJobRole = [];
            }
            this.$axios({
                method: "get",
                params: {
                    user_id: empl_id,
                    company_id: comp_id
                },
                url: this.$CheckEmployeeAttendance,
                headers: this.getAuthHeader()
            }).then(res => {
                if (res.data.status == 402) {
                    $root.$toast.error(res.data.message);
                    this.checkAttendance = true;
                } else if (res.data.status == 200) {
                    this.checkAttendance = false;
                    this.jobRoles = this.getCompanies.filter(
                        val => val.id == event.target.value
                    )[0].jobRoles;
                }
            });

        },
        activeMe(activeBtn) {

            var deactivateBtn = "";

            if (activeBtn == "yes") {
                this.managerAccess = 'yes';
                deactivateBtn = "no";
            } else {
                this.managerAccess = 'no';
                deactivateBtn = "yes"
            }

            $('.' + deactivateBtn).removeClass('btn-primary');
            $('.' + activeBtn).addClass('btn-primary');

        },
        salaryActiveBtn(activeBtn) {
            if (activeBtn == "yes") {
                this.remoteWork = 'yes';
                $('#salary-no').removeClass('btn-primary');
                $('#salary-yes').addClass('btn-primary');
            } else {
                this.remoteWork = 'no';
                $('#salary-yes').removeClass('btn-primary');
                $('#salary-no').addClass('btn-primary');
            }
        },
        pswdShowHide() {
            if (this.type == 'password') {
                this.type = 'text';
                $('.pswdShowHideCls').addClass('show-pass')
            } else {
                this.type = 'password';
                $('.pswdShowHideCls').removeClass('show-pass')
            }
        }
    }
}
</script>

<style scoped>
.input-wrapper {
    position: relative;
}

.input-wrapper .form-control {
    padding-right: 20px;
}

.input-wrapper .ico-eye_selected {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: auto;
    right: 5px;
    cursor: pointer;
}

.textRed {
    color: red;
}

.date-picker-width {
    /* height: 100px; */
    width: 100% !important;
}

.picker-input {
    border: 0 !important;
    background: #f6f6f6 !important;
    box-shadow: none !important;
    height: 50px !important;
}
</style>
